import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function UserCheck({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>UserCheck</title>
      <path
        d="M14.5303 17.4697C14.2374 17.1768 13.7626 17.1768 13.4697 17.4697C13.1768 17.7626 13.1768 18.2374 13.4697 18.5303L14.5303 17.4697ZM16 20L15.4697 20.5303C15.7626 20.8232 16.2374 20.8232 16.5303 20.5303L16 20ZM22.5303 14.5303C22.8232 14.2374 22.8232 13.7626 22.5303 13.4697C22.2374 13.1768 21.7626 13.1768 21.4697 13.4697L22.5303 14.5303ZM3.25 20C3.25 20.4142 3.58579 20.75 4 20.75C4.41421 20.75 4.75 20.4142 4.75 20H3.25ZM12.75 14.75C13.1642 14.75 13.5 14.4142 13.5 14C13.5 13.5858 13.1642 13.25 12.75 13.25V14.75ZM13.4697 18.5303L15.4697 20.5303L16.5303 19.4697L14.5303 17.4697L13.4697 18.5303ZM16.5303 20.5303L22.5303 14.5303L21.4697 13.4697L15.4697 19.4697L16.5303 20.5303ZM4.75 20V19H3.25V20H4.75ZM4.75 19C4.75 16.6528 6.65279 14.75 9 14.75V13.25C5.82436 13.25 3.25 15.8244 3.25 19H4.75ZM14.25 7C14.25 8.79493 12.7949 10.25 11 10.25V11.75C13.6234 11.75 15.75 9.62335 15.75 7H14.25ZM11 10.25C9.20507 10.25 7.75 8.79493 7.75 7H6.25C6.25 9.62335 8.37665 11.75 11 11.75V10.25ZM7.75 7C7.75 5.20507 9.20507 3.75 11 3.75V2.25C8.37665 2.25 6.25 4.37665 6.25 7H7.75ZM11 3.75C12.7949 3.75 14.25 5.20507 14.25 7H15.75C15.75 4.37665 13.6234 2.25 11 2.25V3.75ZM9 14.75H12.75V13.25H9V14.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
